import { ButtonLabel } from './pdpProductLabels'

/**
 * Get Cart button status
 * @param isInstock
 * @param buttonActionLabel
 * @param isBundleButtonDisabled
 * @returns
 */
export const getButtonLabel = (
    isInstock: boolean,
    buttonActionLabel: string,
    isBundleButtonDisabled: boolean
): ButtonLabel | string => {
    if (isInstock) {
        return ButtonLabel.OUT_OF_STOCK
    }

    if (isBundleButtonDisabled) {
        return ButtonLabel.SELECT_A_VARIANT
    }

    return buttonActionLabel
}
